import { render } from "./UpdateStatus.vue?vue&type=template&id=64143120&scoped=true"
import script from "./UpdateStatus.vue?vue&type=script&lang=js"
export * from "./UpdateStatus.vue?vue&type=script&lang=js"

import "../../../assets/css/inner.css?vue&type=style&index=0&id=64143120&scoped=true&lang=css"

import exportComponent from "C:\\Users\\TATS\\Documents\\Projects\\PHP-Laravel\\TatSingWeb\\tsg-exec\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64143120"]])

export default __exports__